
export const AllegroAuthBroadcastName = "AllegroAuth";
export const AllegroAuthBroadcastSuccessEvent = "AllegroAuthSuccess";